import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';

import './mobileMenu'

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, EffectCoverflow, Thumbs } from 'swiper/modules';

import 'swiper/swiper-bundle.css';

//Lightgallery
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

//Lenis
import Lenis from '@studio-freight/lenis'

const lenis = new Lenis()

lenis.on('scroll', (e) => {
  //console.log(e)
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


$("document").ready(function() {
  
 
    

  $(window).scroll(function () {
    if ($(window).scrollTop() > 0) {
        $('header').addClass('scrolling');
    
    } else {
        $('header').removeClass('scrolling');

    }


});

  $('.hamburger-lines').click(function() {
    $(this).toggleClass('active');
      $('.mobileMenu').toggleClass('active');

      return false;
  });




if (document.querySelectorAll('.testimonialSwiper').length > 0) {


  let testimonialSwiper = new Swiper(".testimonialSwiper", {
    modules: [Navigation, EffectCoverflow],
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    loop: false,
    loopAdditionalSlides: 2,
    initialSlide: 0,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 70,
      modifier: 7,
      slideShadows: false,
    },
    navigation: {
      nextEl: ".testimonialRight",
      prevEl: ".testimonialLeft",
    },
  });
}

if (document.querySelectorAll('.galleryCarousel').length > 0) {
  let galleryThumbSwiper = new Swiper(".galleryThumbSwiper", {
    modules: [Navigation],
    spaceBetween: 10,
    slidesPerView: 'auto',
    centeredSlides: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".galleryThumbSwiper .swiper-button-next",
      prevEl: ".galleryThumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      319: {
        slidesPerView: 2,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: true,
      },
      1024: {
        slidesPerView:6,
        centeredSlides: true,
      }
    }
  });

  let galleryMainSwiper = new Swiper(".galleryMainSwiper", {
    modules: [Navigation, EffectFade, Thumbs],
    spaceBetween: 10,
    effect: 'fade',
    thumbs: {
      swiper: galleryThumbSwiper,
    },
  });

  // Sync thumbnails with main slider
  galleryThumbSwiper.on('slideChange', function() {
    galleryMainSwiper.slideTo(galleryThumbSwiper.activeIndex);
  });

  // Keep active thumbnail centered
  galleryMainSwiper.on('slideChange', function() {
    galleryThumbSwiper.slideTo(galleryMainSwiper.activeIndex);
  });

  if (typeof lightGallery !== 'undefined') {
    lightGallery(document.getElementById('gallerySlider'), {
      selector: '.swiper-slide',
      thumbnail: true,
      animateThumb: true,
      zoomFromOrigin: true,
      allowMediaOverlap: true,
      toggleThumb: true,
    });
  }
}
  if ($('.accordion').length > 0) {
      $('.accordionHeader').click(function() { 
          $(this).parent().toggleClass('active');
          $(this).parent().find('.accordionContent').slideToggle();

          
          return false;
      });                
  }
  if ($('.heroImage').length > 0) {
      const ctaElements = document.querySelectorAll('.heroImage .ctaElement');

    ctaElements.forEach(function(element) {
        element.addEventListener('click', function() {
            const isActive = this.classList.contains('active');

            // Remove active class from all CTAs
            ctaElements.forEach(function(el) {
                el.classList.remove('active');
            });

            // Toggle active class on clicked element
            if (!isActive) {
                this.classList.add('active');
            }
        });
    });

  }
    if ($('.galleryItem').length > 0) {
     
      lightGallery(document.getElementById('gallery'), {
          plugins: [lgZoom, lgThumbnail],
          speed: 500,
          licenseKey: '9103CF58-FD6A-4DF5-94DF-29E779C44F84',
          selector: '.galleryItem'
      });
    }
if ($('.newsletterTrigger').length > 0) {
  $('.newsletterTrigger').click(function() {
    $('.newsletterOverlay, .newsletterOverlayBox').show();
    return false;
  });

  $('.newsletterOverlay .closeBtn, .newsletterOverlayBox .closeBtn').click(function() {
    $('.newsletterOverlay, .newsletterOverlayBox').hide();
    return false;
  });
}

    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var targetHash = this.hash;
            var decodedHash = decodeURIComponent(targetHash);
            var target = $(decodedHash);
            
            target = target.length ? target : $('[name=' + decodedHash.slice(1) +']');
            
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 200
                }, 1000);
                return false;
            }
        }
    });

});